/**
 * Builds the review category filters from the rendered cards.
 *
 * The categories are read from the DOM rather than from Liquid: reading
 * block.settings.category while looping section.blocks returned nothing, even
 * though the block itself renders the value fine. Reading what actually
 * shipped avoids depending on that.
 *
 * Slides are hidden rather than removed so the carousel's paging maths keeps a
 * stable set of children.
 */
(() => {
  document.querySelectorAll('.ms-review-carousel').forEach((section) => {
    const host = section.querySelector('[data-review-filters]');
    const items = [...section.querySelectorAll('.ms-review-carousel__item')];
    if (!host || !items.length) return;

    const categoryOf = (item) =>
      item.querySelector('[data-review-category]')?.dataset.reviewCategory?.trim() || '';

    const categories = [...new Set(items.map(categoryOf).filter(Boolean))];
    // One category is not a filter, it is a label.
    if (categories.length < 2) return;

    const track = section.querySelector('[data-ms-carousel-track]');
    const carousel = section.querySelector('ms-carousel');

    const make = (label, value, active) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `ms-review-filter${active ? ' is-active' : ''}`;
      button.dataset.reviewFilter = value;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', active ? 'true' : 'false');
      button.textContent = label;
      return button;
    };

    // Without an "All" button the first category has to start selected,
    // otherwise the carousel opens showing every review under a filter that
    // claims otherwise.
    const showAll = host.dataset.showAll !== 'false';
    const buttons = [
      ...(showAll ? [make(host.dataset.allLabel || 'All', '', true)] : []),
      ...categories.map((c, i) => make(c, c, !showAll && i === 0)),
    ];
    host.replaceChildren(...buttons);
    host.hidden = false;

    const apply = (wanted) => {
      items.forEach((item) => {
        const category = categoryOf(item);
        // An uncategorised review belongs under every filter.
        item.hidden = Boolean(wanted) && category !== wanted && category !== '';
      });
      track?.scrollTo({ left: 0, behavior: 'instant' });
      carousel?.dispatchEvent(new Event('resize'));
      window.dispatchEvent(new Event('resize'));
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((other) => {
          const on = other === button;
          other.classList.toggle('is-active', on);
          other.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        apply(button.dataset.reviewFilter);
      });
    });

    if (!showAll) apply(categories[0]);
  });
})();
